import { triggerTracking, trackSegmentAndGAEvent } from '@zoopla/tracking';

import { BuyerType } from './helpers/calculate-stamp-duty';

export const trackPriceClick = (trackingCategory: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: trackingCategory,
        eventAction: 'click',
        eventLabel: 'stamp duty price'
    });
};

export interface StampHash {
    [details: string]: string;
}

export const STAMPDUTY_LIST_ITEM: StampHash = {
    'First time buyer': '1',
    'I am moving home and this is my only property': '0',
    'I am buying an additional property': '0'
};

export const TRACKING_STAMPDUTY_EVENT = 'Stamp Duty Calculate';

const getEventLabel = (buyerType: BuyerType) => {
    switch (buyerType) {
        case 'first-time-buyer':
            return 'stamp duty status - first time buyer';
        case 'not-first-time-buyer':
            return 'stamp duty status - homeowner moving';
        case 'second-home':
            return 'stamp duty status - homeowner additional';
    }
};

export const trackPropertyStatus = (
    buyerType: BuyerType,
    trackingCategory: string
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: trackingCategory,
        eventAction: 'click',
        eventLabel: getEventLabel(buyerType)
    });
};

export const trackCalculate = (trackingCategory: string) => {
    const stampCalcContainer: HTMLElement | null = document.querySelector(
        'div[data-testid="stamp-duty-calculator"]'
    );
    const stampCalcBody = stampCalcContainer?.parentElement;
    const stampBuyerOption: string | null | undefined =
        stampCalcBody?.querySelector(
            'button[data-testid="stamp-duty-buyer-option"]'
        )?.firstElementChild?.textContent;

    trackSegmentAndGAEvent(
        TRACKING_STAMPDUTY_EVENT,
        {
            eventCategory: trackingCategory,
            eventAction: 'click',
            eventLabel: 'stamp duty calculate',
            eventValue: stampBuyerOption
                ? STAMPDUTY_LIST_ITEM[stampBuyerOption]
                : '0'
        },
        '/for-sale/details/',
        {
            brand: 'zoopla',
            page: '/for-sale/details/',
            section: 'for-sale'
        }
    );
};
